import { LogMapper } from './base';

export class AnesthesiologyMapper extends LogMapper {
  static specialty = 'anesthesiology'
  static columns = ['autonomy', 'sex']

  static components = {
    'anesthesia-type': {
      options: super.standardOptions,
      checker: (log, _, option) => {
        const anesthesiaTypes = {
          // use an object since the id's on the Options don't match the keys in log
          'general': 'general-anesthesia',
          'loco-regional': 'loco-regional-anesthesia',
          'sedoanalgesia': 'sedoanalgesia',
          'cam': 'cam'
        }
        if (option.value === 'combined' && !log['combined-anesthesia']){
          return false
        }
        return !!log[anesthesiaTypes[option.value]]
      }
    }
  }
}

